import React from 'react';
import { Chip as HeroChip } from '@heroui/react';

export interface ChipProps {
  children?: React.ReactNode;
  variant?:
    | 'solid'
    | 'faded'
    | 'bordered'
    | 'light'
    | 'flat'
    | 'dot'
    | 'shadow';
  color?: 'default' | 'primary' | 'success' | 'warning' | 'danger';
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  size?: 'sm' | 'md' | 'lg';
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  isDisabled?: boolean;
  isCloseable?: boolean;
  onClose?: () => void;
  className?: string;
  /** Per-slot class overrides forwarded to HeroUI's Chip. Use the
   *  `content` slot to flip wrapping (`whitespace-normal break-words
   *  text-left`) and the `base` slot to relax the fixed height
   *  (`h-auto py-1 max-w-full`) when the chip needs to flow across
   *  multiple lines. The default `content: 'flex items-center'` is
   *  merged so existing callers don't lose start/end alignment. */
  classNames?: {
    base?: string;
    content?: string;
    dot?: string;
    avatar?: string;
    closeButton?: string;
  };
  onClick?: () => void;
}

const Chip: React.FC<ChipProps> = ({
  children,
  variant = 'faded',
  color = 'default',
  radius = 'md',
  size = 'md',
  startContent,
  endContent,
  isDisabled = false,
  isCloseable = false,
  onClose,
  className,
  classNames,
  onClick,
}) => {
  return (
    <HeroChip
      variant={variant}
      color={color}
      radius={radius}
      size={size}
      classNames={{
        ...classNames,
        content: `flex items-center ${classNames?.content ?? ''}`.trim(),
      }}
      startContent={
        startContent ? <div className="px-1">{startContent}</div> : undefined
      }
      endContent={
        endContent ? <div className="px-1">{endContent}</div> : undefined
      }
      isDisabled={isDisabled}
      isCloseable={isCloseable}
      onClose={onClose}
      className={className}
      onClick={onClick}
    >
      {children}
    </HeroChip>
  );
};

export default Chip;
